/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, limit: NonNullable<unknown> }} Cv_Check_Remaining_ReviewsInputs */

const en_cv_check_remaining_reviews = /** @type {(inputs: Cv_Check_Remaining_ReviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} of ${i?.limit} checks available`)
};

const de_cv_check_remaining_reviews = /** @type {(inputs: Cv_Check_Remaining_ReviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} von ${i?.limit} Checks verfügbar`)
};

/**
* | output |
* | --- |
* | "{remaining} of {limit} checks available" |
*
* @param {Cv_Check_Remaining_ReviewsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_remaining_reviews = /** @type {((inputs: Cv_Check_Remaining_ReviewsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Remaining_ReviewsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_remaining_reviews(inputs)
	return en_cv_check_remaining_reviews(inputs)
});